/**
 * O watch de login e leve (useUserSession ja carregado por outra parte da
 * app) e fica de pe desde o boot — so o corpo do sync (stores dos shorts +
 * tracking) e import dinamico, fora do entry, e so baixa quando um login de
 * fato acontece. Antes o watch inteiro vivia atras do import adiado por
 * idle/timeout (ate 10s): um login completando dentro dessa janela nunca
 * era observado e o sync de views offline era perdido silenciosamente.
 */
export default defineNuxtPlugin(nuxtApp => {
	nuxtApp.hook('app:suspense:resolve', () => {
		const { loggedIn } = useUserSession();
		watch(loggedIn, (isLoggedIn, wasLoggedIn) => {
			if (!isLoggedIn || wasLoggedIn) return;
			// O contexto Nuxt pode ter morrido nesse intervalo (aba fechada,
			// teardown): sync de views nunca deve quebrar o boot.
			void import('~/composables/propertyViewSync/setupPropertyViewSync')
				.then(m =>
					nuxtApp.runWithContext(() => m.handlePropertyViewSyncOnLogin())
				)
				.catch(() => {});
		});
	});
});
